import { useEffect, useRef, useState } from "react";
import search from "../assets/blog/search.svg";
import Card from "../components/blog/card";
import axios from 'axios';
import ScheduleSession from "../components/blog/scheduleSession";

export default function BlogSearch() {

    const [searchText, setSearchText] = useState("");
    const [filterStack, setFilterStack] = useState([]);
    const [allBlogs, setAllBlogs] = useState();
    const [visibleCount, setVisibleCount] = useState(6);
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [shownBlogs, setShownBlogs] = useState([]);
    const searchBarReff = useRef();

    async function FetchBlogs(){
        const response = await axios.get('${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/blog');
        setAllBlogs(response.data);
        setFilteredBlogs(response.data);
        setShownBlogs(response.data.slice(0, visibleCount));
    }

    const filterFunction = () => {
        let updatedBlogList = allBlogs;

        // If there are filters in the filterStack or searchText is not empty, filter the blogs
        if (filterStack.length > 0 || searchText.trim() !== "") {
            updatedBlogList = allBlogs.filter((blog) => {

                // Check if the blog matches any filter in the filterStack
                const matchesFilterStack = filterStack.length === 0 || filterStack.some((filter) => {
                    // Match with title
                    const matchesTitle = blog.title.toLowerCase().includes(filter.toLowerCase());

                    // Match with attributes (tags)
                    const matchesAttributes = blog.attributes?.some((attr) =>
                        attr.toLowerCase().includes(filter.toLowerCase())
                    );

                    // Return true if either title or attributes match the filter
                    return matchesTitle || matchesAttributes;
                });

                // Check if the blog matches the searchText
                const matchesSearchText = searchText.trim() === "" ||
                    blog.title.toLowerCase().includes(searchText.toLowerCase()) || // Match with title
                    blog.attributes?.some((attr) => attr.toLowerCase().includes(searchText.toLowerCase())); // Match with attributes

                // Return true only if the blog matches both the filterStack and searchText
                return matchesFilterStack && matchesSearchText;
            });
        }

        setFilteredBlogs(updatedBlogList);
    };

    useEffect(()=>{
        FetchBlogs();
    },[]);

    useEffect(()=>{
        setShownBlogs(filteredBlogs?.slice(0,visibleCount));
    },[visibleCount, filteredBlogs]);

    useEffect(()=>{
        filterFunction();
    },[searchText, filterStack]);

    const handleKeyDown = (e) => {
        if(e.key === "Enter" && searchText.trim() !== ""){
            setFilterStack([...filterStack, searchText.trim()]);
            setSearchText("");
        }
    }

    const removeFilter = async (filterToBeRemoved) => {
        const updatedFilter = filterStack.filter((filter) => filter !== filterToBeRemoved);
        setFilterStack(updatedFilter);
    }

    return(
        <div className="w-[85%] xl:w-[75%] mx-auto px-6 md:px-10 py-6">
            <section className="w-full h-full">
                <div className="flex pb-1 items-center flex-col gap-4 sm:gap-0 sm:justify-between sm:flex-row">
                    <p className="text-primary-color text-3xl font-medium	">
                        <span className="underline underline-offset-8 decoration-primary-color">Blog</span> Search
                    </p>
                    <div className="w-full pt-4 relative flex items-center justify-end sm:w-1/2 md:w-1/3">
                        
                        <input 
                            type="text" 
                            ref={searchBarReff}
                            value={searchText || ""} 
                            onChange={(e)=>setSearchText(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="Search..."
                            className="rounded-lg w-full px-4 py-0.5 border border-[#999999]"
                        />
                                {!!searchText ? (
                                    <button 
                                        onClick={()=> {
                                            setSearchText("");
                                            searchBarReff.current.focus();
                                        }} 
                                        type="button" 
                                        className="w-6 h-6 z-30 bg-white absolute right-[8px] sm:right-[8px]"
                                    >
                                        <svg className="stroke-red-500" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13 3L3 13M3 3L13 13"  stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>
                                ) : (
                                    <img 
                                        onClick={()=>{searchBarReff.current.focus()}} 
                                        src={search} alt="searchicon" 
                                        className="w-6 h-6 z-30 bg-white absolute right-[8px] sm:right-[8px]" 
                                    />
                                )}
                    </div>
                </div>
                <div className="w-full pt-4 pb-4 flex justify-start gap-3">
                    {filterStack.map((filter) => (
                        <div key={filter} className="flex stroke-[#04236b] hover:stroke-white gap-3 px-4 py-1.5 group justify-between bg-[#04236B1A] rounded-full hover:bg-primary-color text-primary-color hover:text-white ">
                        <p>{filter}</p>
                        <button onClick={()=> removeFilter(filter)} type="button" className=" relative ">
                            {/* <img src={cross} alt="crossicon" className="stroke-primary-color w-5 h-5" /> */}
                            <svg className="hover:stroke-red-500" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 3L3 13M3 3L13 13"  stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    ))}
                </div>
                <div className="my-4 flex flex-wrap justify-start items-center gap-4 sm:grid sm:grid-cols-2 lg:grid-cols-3 md:gap-5 xl:gap-7  ">
                    {shownBlogs?.map((item) => (
                        <Card id={item.id} key={item._id} image={item?.coverImage} tags={item.attributes} title={item.title} view={item.views} description={item.content[0]?.content} createdBy={item?.createdBy} date={item?.date}  />
                    ))}
                </div>
                <div className="w-full hidden sm:flex text-center justify-center py-2  text-white">
                    {filteredBlogs?.length > visibleCount && (
                        <button onClick={()=> setVisibleCount(prev => prev + 9)} className="block bg-primary-color px-3 py-2 rounded-lg">
                        Load More
                    </button>
                    )}
                </div>
            </section>
            <div className="w-full py-8">
                <ScheduleSession />
            </div>
        </div>
    );
}